import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { formatRON } from "../lib/shop";
import { useT } from "../lib/i18n";

export default function ProductCard({ p, index = 0 }) {
  const { t } = useT();
  const discount = p.old_price ? Math.round((1 - p.price / p.old_price) * 100) : null;
  return (
    <Link to={`/produs/${p.slug}`} className="group block anim-fade-up" style={{ animationDelay: `${index * 80}ms` }} data-testid={`product-card-${p.id}`}>
      <div className="border border-gray-200 bg-white overflow-hidden relative flex flex-col h-full hover:border-gray-900 transition-colors">
        <div className="aspect-[4/3] bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
          <img src={p.images[0]} alt={p.name} className="w-full h-full object-contain p-6 product-img" />
          {discount && (
            <span className="absolute top-3 left-3 bg-gray-900 text-white text-xs font-bold px-2 py-1 font-mono">−{discount}%</span>
          )}
          <span className="absolute top-3 right-3 text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400">{p.category === 'cutite' ? t("nav.knives") : t("nav.tools")}</span>
        </div>
        <div className="p-5 flex flex-col flex-1 border-t border-gray-200">
          <h3 className="font-display text-lg font-bold leading-snug text-gray-900 line-clamp-2 min-h-[3.5rem]">{p.short_name}</h3>
          <p className="mt-1 text-sm text-gray-500 line-clamp-2">{p.description?.slice(0, 90)}…</p>
          <div className="mt-auto pt-5 flex items-end justify-between">
            <div>
              {p.old_price && <p className="text-xs text-gray-400 line-through font-mono">{formatRON(p.old_price)}</p>}
              <p className="font-display text-2xl font-black font-mono text-gray-900" data-testid={`price-${p.id}`}>{formatRON(p.price)}</p>
            </div>
            <span className="flex items-center gap-1 text-xs font-bold uppercase tracking-widest text-gray-900 group-hover:translate-x-1 transition-transform">
              {t("product.view")} <ArrowRight size={14} strokeWidth={2} />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
